module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (142).49429ed6.jpg";